import React from 'react'
import './ImageStyleSheet.css';

function EducationCLRHS1() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/crlhs1.jpeg" className='img-view'/>
        </div>
    )
}

export default EducationCLRHS1
